import { useParams } from "react-router-dom";
import React, { useState, useEffect } from 'react'
import { Form, Tabs, Tab, Row, Col, Container, } from 'react-bootstrap'
import HomeMainComponent from '../organisation_component/HomeMainComponent';
import Organisation from '../organisation_component/organisation';
import * as apiUtility from '../../config/APIUtils';
import './tabs.css';
import MessageBox from '../Utility/MessageBox';
import SessionTimeoutContainer from '../Utility/SessionTimeoutContainer';
import { Badge } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useUserCourse } from '../../config/UserCourseContext';
import ManageMyTrainings from './ManageMyTrainings';
import TrainingCart from "./TrainingCart";
import UserProfileUpdated from "./UserProfileUpdated";
import useTheme from '@mui/system/useTheme';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useUser } from "../../config/UserContext";
import HelpIconInfo from "../Utility/HelpIconBox";
import { Box, FormLabel, Option, Select, Sheet, Stack, Typography } from "@mui/joy";
import { width } from "@mui/system";

function UserHomePage(props) {


    const theme = useTheme();
    const isSmScreen = useMediaQuery(theme.breakpoints.down('sm'));


    const [homeIdForUser, setomeIdForUser] = useState("");
    const [orgIdForAdmin, setOrgIdForAdmin] = useState("");
    const [homeDetails, setHomeDetails] = useState([]);
    const [orgDet4DrpDwn, setOrgDet4DrpDwn] = useState([]);
    const [orgCount, setOrgCount] = useState('1');
    const [homeDetailList, setHomeDetailList] = useState([]);
    const [orgDetailList, setOrgDetailList] = useState([]);
    const [orgTabFlag, setOrgTabFlag] = useState(false);
    const [homeTabFlag, setHomeTabFlag] = useState(true);
    const [userId, setUserId] = useState('');
    const [hideOrgComponent, setHideOrgComponent] = useState(false);
    const [hideHomeComponent, setHideHomeComponent] = useState(false);


    const { updateScreenDetails } = useUser();
    const { cartCourseCount, updateCartCourseCount, updateCartCourseList, clearUserCourseContext } = useUserCourse();


    var paramId = useParams().id;
    useEffect(() => {
        var user = "";
        if (paramId !== undefined) {
            setUserId(paramId)
            user = paramId;
        } else if (props.userId !== undefined) {
            setUserId(props.userId)
            user = props.userId;
        }
        if (user != undefined && user != "") {
            clearUserCourseContext();
            temMethod(user);
            //fetchTrainingCartCourses(user);
        }
    }, [props.userId])

    useEffect(() => {
        updateScreenDetails(isSmScreen);
    }, [isSmScreen]);

    const temMethod = (user) => {
        setHomeDetails(JSON.parse(sessionStorage.getItem("allHomeArr")));
        setOrgDet4DrpDwn(JSON.parse(sessionStorage.getItem("OtherOrgId")));
        if (sessionStorage.getItem("userType") === 'admin')
            setHideOrgComponent(true);
        const getOrgListFromUserId = "orgnization/getOrgInfoForUserLogin/"
        var apiRequest = apiUtility.apiInputRequest;
        apiRequest.endPoint = getOrgListFromUserId;
        apiRequest.data = {
            "user_id": user,
            "isAdmin": false,
            "homeList": (JSON.parse(sessionStorage.getItem("allHomeArr")))
        };
        apiUtility.sendAPIDataPOST(apiRequest)
            .then(res => {
                for (let data of res.data) {
                    if (data.orgListFromUserId != undefined && data.orgListFromUserId != "") {
                        setOrgDetailList(data.orgListFromUserId);
                        setOrgTabFlag(true);
                    } else {
                        setOrgTabFlag(false);
                        setOrgDetailList([])
                    }
                    if (data.homeListDetail != undefined && data.homeListDetail != "") {
                        setHomeTabFlag(true);
                        setHomeDetailList(data.homeListDetail)
                    } else {
                        setHomeTabFlag(false);
                        setHomeDetailList([])
                    }
                    setOrgCount(String(parseInt(data.getOrgCount) + 1))
                    setOrgDet4DrpDwn(JSON.parse(sessionStorage.getItem("OtherOrgId")))
                }
            })
            .catch(err => {
                console.log(err);
            })
    }

    const fetchTrainingCartCourses = async (user) => {
        var apiRequest = apiUtility.apiInputRequest;
        apiRequest.endPoint = "user/fetchTrainingCartList/" + user;
        await apiUtility.fetchAPIDataGET(apiRequest)
            .then(res => {
                updateCartCourseList(res.data);
                updateCartCourseCount(res.data);
            })
            .catch(err => {
                console.log(err);
            })
    }

    // var createHomeIDSelectItems = () => {
    //     let items = [];
    //     for (var i = 0; i < homeDetailList.length; i++) {
    //         items.push(<option value={homeDetailList[i].home_id}> {homeDetailList[i].name} </option>);
    //     }
    //     return items;
    // }

    function changeHomeId(homeID) {
        if (homeID != '') {
            setHideHomeComponent(false);
            setomeIdForUser(homeID);
            sessionStorage.setItem("homeId", homeID);
        } else {
            setHideHomeComponent(true);
        }
    }

    function changeOrganisation(orgId) {
        if (orgId != "") {
            setHideOrgComponent(false);
            sessionStorage.setItem("orgId", orgId)
            setOrgIdForAdmin(String(orgId))
        } else {
            setHideOrgComponent(true);
        }
    }

    const CartTitle = ({ count }) => {
        const displayCount = Array.isArray(count) ? count.length : (count || 0);
        return (
            <React.Fragment>
                Training Cart &nbsp;
                <Badge color="warning" badgeContent={displayCount}>
                    <ShoppingCartIcon />
                </Badge>
            </React.Fragment>
        );
    }


    return (
        <Container fluid style={{ marginTop: "8vh" }}>
            <Row>
                <div style={{ position: 'relative', width: '100%' }}>
                    <Tabs defaultActiveKey="profile" id="uncontrolled-tab-example" className="mb-3">
                        <Tab as={Col} eventKey="profile" title="My Profile">
                            <UserProfileUpdated userId={props.userId} homeId={props.homeID} />
                        </Tab>
                        <Tab as={Col} eventKey="employment" title="Manage My Training">
                            <ManageMyTrainings userId={props.userId} homeId={props.homeID} />
                        </Tab>
                        {/* <Tab as={Col} eventKey="trainingCart" title={
                            <CartTitle count={cartCourseCount} />
                        }>
                            <TrainingCart userId={props.userId} homeId={props.homeID} />
                        </Tab> */}
                        {orgTabFlag && (
                            <Tab as={Col} eventKey="organizationView" title="Manage Organizations" >
                                {/* {(sessionStorage.getItem("userType") && sessionStorage.getItem("userType") == 'admin') && */}

                                    <Box sx={{ mx: "auto", p: 2 }}>
                                        <Sheet variant="soft" color="primary" sx={{ p: 2, borderRadius: "md", display: "flex" }}>
                                            <Stack direction="column" sx={{ width: "100%", justifyContent: "center", alignItems: "center" }}>
                                                <FormLabel sx={{ p: 1 }}>Organization</FormLabel>
                                                <Select
                                                    style={{ "borderRadius": "20px", width: 500 }}
                                                    placeholder="Please select Organization"
                                                    size={"lg"}
                                                    onChange={(_, val) => changeOrganisation(val)}
                                                >
                                                    {orgDetailList.map((item, _id) => {
                                                        return <Option key={_id} value={item.permission_of_id}>
                                                            {item.name}
                                                        </Option>
                                                    })}
                                                </Select>

                                            </Stack>
                                        </Sheet>
                                        <br></br>
                                        <Sheet variant="outlined" color="primary" sx={{ p: 2, borderRadius: "md" }}>
                                            {!hideOrgComponent && orgIdForAdmin ?
                                                <Organisation userId={userId} orgIdForAdmin={orgIdForAdmin} fromUser={true} />
                                                : <MessageBox data="Select an organization to view" />}
                                        </Sheet>
                                    </Box>

                               


                            </Tab>

                        )}
                        {homeTabFlag && (

                            <Tab as={Col} eventKey="homeView" title="Manage Homes" >

                                <Box sx={{ mx: "auto", p: 2 }}>
                                    <Sheet variant="soft" color="primary" sx={{ p: 2, borderRadius: "md", display: "flex" }}>
                                        <Stack direction="column" sx={{ width: "100%", justifyContent: "center", alignItems: "center" }}>
                                            <FormLabel sx={{ p: 1 }}>Home</FormLabel>
                                            <Select
                                                style={{ "borderRadius": "20px", width: 500 }}
                                                placeholder="Please select Home"
                                                size={"lg"}
                                                onChange={(_, val) => changeHomeId(val)}
                                            >
                                                {homeDetailList.map((item, _id) => {
                                                    return <Option key={_id} value={item.home_id}>
                                                        {item.name}
                                                    </Option>
                                                })}
                                            </Select>

                                        </Stack>
                                    </Sheet>
                                    <br></br>
                                    <Sheet variant="outlined" color="primary" sx={{ p: 2, borderRadius: "md" }}>
                                        {(homeIdForUser == "" || hideHomeComponent) ? <MessageBox data="Select a home to view" /> :
                                            <HomeMainComponent userId={userId} homeIdFprAdmin={homeIdForUser} fromUser={true} />

                                        }
                                    </Sheet>
                                </Box>
                            </Tab>
                        )}
                    </Tabs>
                    <div style={{ position: 'absolute', right: 12, top: 8, zIndex: 10 }}>
                        <HelpIconInfo link={"https://carepassportcareltc.atlassian.net/wiki/external/MWZkYTUyNzY1NDY1NDM5Zjk3Mzg2ODI2NzYxNDlkMDY"} msg={""} />
                    </div>
                </div>
            </Row>
            <SessionTimeoutContainer />
        </Container>)
}

export default UserHomePage;